import { enableProdMode } from '@angular/core';
import '@angular/compiler';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.sentry_env && environment.sentry_env === 'production' && environment.sentry_dsn && environment.sentry_targets) {
  // Sentry.init({
  //   environment: environment.sentry_env,
  //   dsn: environment.sentry_dsn,
  //   integrations: [
  //     new BrowserTracing({
  //       tracePropagationTargets: environment.sentry_targets,
  //       routingInstrumentation: Sentry.routingInstrumentation,
  //     }),
  //   ],
  //   tracesSampleRate: 1.0,
  // });

  Sentry.init({
    environment: environment.sentry_env,
    dsn: environment.sentry_dsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: environment.sentry_targets,
    tracesSampleRate: 0.1, // Set to 1.0 to capture all transactions
  });
}

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
  console.log('Running on', environment.env);
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));
